export default __webpack_public_path__ + "static/media/location.37e434b4.svg";